module.exports = "### Switch It Up With Themes\n\nIt’s easy to match Mineral components to a product experience with themes.\nWith just a few lines of code, change the theme for every component or constrain\nthe change to only affect a portion of them. Themes are simple enough to quickly\nchange the color palette and powerful enough to adjust a\n[whole host of other properties](/theming/#common-scenarios-theme-structure).\n\n<PlaygroundButton to=\"/theming\">\n  Learn About Themes\n</PlaygroundButton>\n"


//////////////////
// WEBPACK FOOTER
// ./src/website/app/pages/Home/content/themePlayground.md
// module id = 514
// module chunks = 9